import React, {useState, useEffect} from 'react';
import DataImage from '../../DataImage';
import {IFoodBanksProps} from '../../utils/models';
import makeSum from '../../../../utils/makeSum';
import {getQuestionBySurvey} from '@/containers/Feba/helpers/mapping';
import image from '../../asset/6. Food out.png'

const TotalFoodOut = ({ submissions }: IFoodBanksProps) => {
    const [surveyId, setSurveyId] = useState<number>(0);

    useEffect(() => {
        if (submissions.length > 0) {
            setSurveyId(Number(submissions[0].survey_id));
        }
    }, []);

    return (
        <DataImage
            image={image}
            value={`Kg ${makeSum(submissions, getQuestionBySurvey(surveyId, 'total_food_out'))}`}
            text='Total Food Out'
        />
    );
}

export default TotalFoodOut;